import { createBlockheadClassName } from 'utils/classnames';

export const SELECT_MENU_MAX_HEIGHT_PX = 280;

export const SELECT_TRIGGER_CLASS_NAME = createBlockheadClassName(
  'Select',
  'Trigger',
);
